<template lang="html">
  <div class="transactions-wrapper">
    <table>
      <thead>
        <tr>
          <td>{{ $t("details.transactions.date") }}</td>
          <td>{{ $t("details.transactions.buyer") }}</td>
          <td class="center" v-for="price in prices" :key="price.prc_id">
            {{
              price.min
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            -
            {{
              price.max
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            <span class="lowercase">{{
              productInfo.mun_unit === "komad" ||
              productInfo.mun_unit === "komada"
                ? $t("item.items")
                : productInfo.mun_unit
            }}</span
            ><br />
            {{
              price.prc_price
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ currency }}
          </td>
          <!-- <td>{{$t('details.transactions.other')}}</td> -->
          <td>{{ $t("details.transactions.condition") }}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in tableData" :key="index">
          <td>{{ user.off_date ? user.off_date : "/" }}</td>
          <td>{{ user.usr_name ? user.usr_name : "/" }}</td>
          <td class="center" v-for="price in prices" :key="price.prc_id">
            {{
              user.prc_id === price.prc_id
                ? user.off_quantity
                    .toLocaleString("en")
                    .split(",")
                    .join(".")
                : "/"
            }}
          </td>
          <!-- <td>{{user.other ? user.other : '/'}}</td> -->
          <td>
            {{
              user.off_type !== undefined ? getTranslation(user.off_type) : "/"
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="info">
      <span class="info-key">{{ $t("details.transactions.quantity") }}:</span>
      <span class="info-value">{{
        quantity
          .toLocaleString("en")
          .split(",")
          .join(".")
      }}</span>
    </div>
    <div class="info">
      <span class="info-key"
        >{{ $t("details.transactions.currentPrice") }}:</span
      >
      <span class="info-value"
        >{{
          currentPrice
            .toLocaleString("en")
            .split(",")
            .join(".")
        }}
        {{ currency }}</span
      >
    </div>
    <div v-if="tableData.length === 0" class="">
      {{ $t("main.noTransactions") }}
    </div>
    <div
      class="small-transactions"
      v-for="(user, index) in tableData"
      :key="index"
    >
      <div class="top">
        <div class="info">
          <div class="key">
            {{ $t("details.transactions.buyer") }}
          </div>
          <div class="value">
            {{ user.usr_name ? user.usr_name : "/" }}
          </div>
        </div>
        <div class="info">
          <div class="key">
            {{ $t("details.transactions.date") }}
          </div>
          <div class="value">
            {{ user.off_date ? user.off_date : "/" }}
          </div>
        </div>
      </div>
      <div class="bottom">
        <div v-for="price in prices" :key="price.prc_id" class="info">
          <div class="key">
            {{
              price.min
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            -
            {{
              price.max
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            <span class="lowercase">{{
              productInfo.mun_unit === "komad" ||
              productInfo.mun_unit === "komada"
                ? $t("item.items")
                : productInfo.mun_unit
            }}</span>
            {{
              price.prc_price
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ currency }}
          </div>
          <div class="value">
            {{
              user.prc_id === price.prc_id
                ? user.off_quantity
                    .toLocaleString("en")
                    .split(",")
                    .join(".")
                : "/"
            }}
          </div>
        </div>
        <div class="info">
          <div class="key">
            {{ $t("details.transactions.condition") }}
          </div>
          <div class="value">
            {{
              user.off_type !== undefined ? getTranslation(user.off_type) : "/"
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
export default {
  name: "itemTransactions",
  props: {
    productInfo: {
      type: Object
    }
  },
  data() {
    return {
      tableData: [],
      prices: [],
      quantity: "",
      currentPrice: "",
      currency: ""
    };
  },
  mounted() {
    this.getTransactions();
  },
  methods: {
    getTransactions() {
      let params = {
        pro_id: this.$route.params.id
      };
      api
        .getProductTransactions(params)
        .then(res => {
          this.tableData = res.data.data;
          this.prices = res.data.meta.prices;
          this.quantity = res.data.meta.off_count;
          this.currentPrice = res.data.meta.current_price;
          this.currency = res.data.meta.cur_id;
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {
    getTranslation() {
      return condition => {
        if (condition === 1) {
          return this.$t("dropdown.condition1");
        } else {
          return this.$t("dropdown.condition2");
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.transactions-wrapper {
  margin-top: 20px;
  margin-right: 20px;
  padding-right: 20px !important;
  max-width: 100vw !important;
  overflow: auto !important;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;

  .small-transactions {
    display: none;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 10px;
    margin-bottom: 10px;

    .top {
      background: #f5f5f5;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      padding: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .info {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-bottom: 0px;

        .key {
          font-weight: 800;
          font-size: 12px;
          line-height: 20px;
          letter-spacing: 0.06em;
          color: rgba(160, 160, 160, 0.9);
          margin-right: 5px;
        }
        .value {
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          letter-spacing: 0.03em;
          color: #606060;
        }
      }
    }
    .bottom {
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .info {
        display: flex;
        flex-direction: column;
        text-align: left;

        .key {
          font-weight: 800;
          font-size: 12px;
          line-height: 20px;
          letter-spacing: 0.06em;
          color: rgba(160, 160, 160, 0.9);
          width: 100%;
          text-align: left;
        }
        .value {
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.03em;
          color: #8e3e4c;
        }
      }
    }
  }

  .info {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 10px;

    .info-key {
      font-weight: normal;
      font-size: 13px;
      line-height: 21px;
      color: #787878;
      margin-right: 15px;
      white-space: nowrap;
    }
    .info-value {
      font-weight: 800;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: $text-color;
    }
  }
  @import "@/assets/scss/tableStyles.scss";
  table {
    margin-bottom: 20px;
    max-width: 100vw !important;
    overflow: auto !important;
    @import "@/assets/scss/scrollbarStyles.scss";
    @include scrollbar;
    thead td span.lowercase {
      text-transform: lowercase;
    }
    thead td {
      white-space: nowrap;
    }
    td.center {
      text-align: center;
    }
  }
}
@media only screen and (max-width: 1000px) {
  table {
    display: none;
  }
  .transactions-wrapper {
    margin: 0;
    margin-bottom: 20px;
    padding-right: 0px !important;
  }
  .small-transactions {
    display: block !important;
  }
}
</style>
